import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export function getBaseUrl() {
  return document.getElementsByTagName('base')[0].href;
}

const providers = [
  { provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }
];

if (environment.production) {
  enableProdMode();
}

// The sign-in callback boots before its token is read, so the app first renders as the
// deployment's own tenant (global/MX) and only then learns the token's org and reloads into it
// (Columbia). Keep the page behind the neutral loader until AuthService has decided.
if (window.location.pathname.startsWith('/signin-callback')) {
  document.body.classList.add('signin-redirecting');
}

platformBrowserDynamic(providers)
  .bootstrapModule(AppModule)
  .catch(err => {
    // The full-screen loader stays until AppComponent marks the app ready; a bootstrap that
    // fails (an APP_INITIALIZER rejecting) never gets there, so it is lifted here instead of
    // spinning forever (PR #2538).
    document.body.classList.add('app-ready');
    document.body.classList.remove('signin-redirecting');
    console.log(err);
  });